import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { LeadDetails } from "../components/lead-details.component";
// import { SequenceDetails } from "../components/sequence.component";
import { CompanyDetails } from "../components/company-details.component";
import { reorder } from "./helper";

export function LeadLeftPannel(props) {
  const [order, setOrder] = useState(["lead", "company", "sequence"]);
  const [viewMoreOrder, setViewMoreOrder] = useState({ lead: false, company: false, sequence: false });

  useEffect(() => {
    const _order = localStorage.getItem("lead-popup-order");
    if (_order) {
      const updated = _order.split(",");
      if (updated.length === 3) {
        setOrder(updated);
      } else {
        setOrder(["lead", "company", "sequence"]);
      }
    } else {
      setOrder(["lead", "company", "sequence"]);
    }
  }, []);

  useEffect(() => {
    const _order = localStorage.getItem("lead-popup-view-more-order");
    if (_order) {
      const _parse = JSON.parse(_order);
      if (Object.keys(_parse).length === 3) {
        setViewMoreOrder(_parse);
      } else {
        setViewMoreOrder({ lead: false, company: false, sequence: false });
      }
    } else {
      setViewMoreOrder({ lead: false, company: false, sequence: false });
    }
  }, []);

  const handleDragEnd = (param) => {
    const a = reorder(order, param.source.index, param.destination.index);
    setOrder(a);
    localStorage.setItem("lead-popup-order", a.join(","));
  };

  const handleViewMoreChange = (module, status) => {
    const _viewMoreOrder = { ...viewMoreOrder };
    _viewMoreOrder[module] = status;
    setViewMoreOrder(_viewMoreOrder);
    localStorage.setItem("lead-popup-view-more-order", JSON.stringify(_viewMoreOrder));
  };

  const lead = (index) => (
    <LeadDetails
      index={index}
      page={props.page}
      pageSub={props.pageSub}
      leadId={props.leadId}
      moduleType={props.moduleType}
      pageForm={props.pageForm}
      basePath={props.basePath}
      sidePanelProps={props.sidePanelProps}
      popupLoading={props.popupLoading}
      popupCellLoading={props.popupCellLoading}
      viewMore={viewMoreOrder["lead"]}
      setViewMore={(status) => handleViewMoreChange("lead", status)}
    />
  );

  const company = (index) => (
    <CompanyDetails
      index={index}
      showSwitchPerson={true}
      page={props.page}
      pageSub={props.pageSub}
      leadId={props.leadId}
      moduleType={props.moduleType}
      pageForm={props.pageForm}
      basePath={props.basePath}
      sidePanelProps={props.sidePanelProps}
      popupLoading={props.popupLoading}
      popupCellLoading={props.popupCellLoading}
      isSecondaryModule={true}
      viewMore={viewMoreOrder["company"]}
      setViewMore={(status) => handleViewMoreChange("company", status)}
    />
  );

  // const sequence = index => <SequenceDetails
  //     index={index}
  //     leadId={props.leadId}
  //     moduleType={props.moduleType}
  // />;

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="droppable-side-panel">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {order.map((each, index) => {
              if (each === "lead") return lead(index);
              else if (each === "company") return company(index);
              // else if (each === "sequence") return sequence(index);
              return <div key={index}></div>;
            })}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
